import React from 'react';
import styled from 'styled-components';
import { Loading } from './Loading';

const LoadingCss = styled.div`
  position: fixed;
  width: 100px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: calc(50% - 20px) calc(50% - 50px);
  background-color: white;
  border-radius: 100px;
  box-shadow: 0 5px -5px 10px #000000;
`;

export const CenterLoading = () => {
    return (
        <LoadingCss>
            <Loading/>
        </LoadingCss>
        
    );
}